"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTitleComponent = exports.getChevronPosition = exports.defaultTitleRenderer = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _text = require("../text");

var _utils = require("../utils");

var _constants = require("./constants");

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

var _excluded = ["headingLevel", "size", "titleText", "toggle"];

// Default chevron position to trailing if card layout is used. Allow overrides.
var getChevronPosition = function getChevronPosition(_ref) {
  var chevronPositionProp = _ref.chevronPositionProp,
      isCardLayout = _ref.isCardLayout;

  if (isCardLayout && chevronPositionProp === undefined) {
    return _interfaces.ExpanderChevronPosition.Trailing;
  }

  if (chevronPositionProp !== undefined) {
    return chevronPositionProp;
  }

  return _interfaces.ExpanderChevronPosition.Leading;
};

exports.getChevronPosition = getChevronPosition;

var getTitleComponent = function getTitleComponent(headingLevel) {
  switch (headingLevel) {
    case 1:
      return _text.H1;

    case 2:
      return _text.H2;

    case 3:
      return _text.H3;

    case 4:
      return _text.H4;

    case 5:
      return _text.H5;

    case 6:
      return _text.H6;

    default:
      return _text.Text;
  }
};

exports.getTitleComponent = getTitleComponent;

var defaultTitleRenderer = function defaultTitleRenderer(_ref2) {
  var headingLevel = _ref2.headingLevel,
      size = _ref2.size,
      titleText = _ref2.titleText,
      toggle = _ref2.toggle,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  var Title = (0, _styledBase.default)(getTitleComponent(headingLevel))({
    cursor: 'pointer'
  });
  return (0, _core.jsx)(Title, (0, _extends2.default)({}, (0, _utils.pickDataProps)(forwardedProps), {
    "aria-hidden": true,
    fontSize: size === _interfaces.ExpanderSize.Small ? 'T200' : 'T300',
    fontWeight: headingLevel ? 'bold' : undefined,
    color: _constants.HEADER_COLOR,
    onClick: toggle
  }), titleText);
};

exports.defaultTitleRenderer = defaultTitleRenderer;